import {createReducer} from "typesafe-actions";
import {SET_FINGERPRINT} from "../actions";

export const fingerprint = createReducer({}).handleAction(SET_FINGERPRINT, (state, action) => action.payload);